import React, {useState} from 'react'
import { useNavigate } from 'react-router-dom'
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { createProduct } from '../utils/api';
import { FaTimes } from "react-icons/fa";

const CreateProduct = () => {
    const [product, setProduct] = useState({
        name: "",
        description: "",
        price: "",
        stock: "",
        category: "jordbær",
        featured: false
    });

    const [image, setImage] = useState(null);
    const [bulkDiscounts, setBulkDiscounts] = useState([]);
    const navigate = useNavigate();

    const handleAddDiscount = () => {
        setBulkDiscounts([...bulkDiscounts, { quantity: null, price: null }]);
    }

    const handleRemoveDiscount = (index) => {
        setBulkDiscounts(bulkDiscounts.filter((_, i) => i !== index));
    };

    const handleDiscountChange = (index, field, value) => {
        const updatedDiscounts = bulkDiscounts.map((discount, i) => 
            i === index ? { ...discount, [field]: value } : discount
        );
        setBulkDiscounts(updatedDiscounts);
    };

    const handleChange = (e) => {
        const {name, value, type, checked } = e.target;

        setProduct((prev) => ({
            ...prev,
            [name]: type === "checkbox" ? checked: value,
        }));
    };

    const handleImageChange = (e) => {
        setImage(e.target.files[0]);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        const formData = new FormData();
        Object.keys(product).forEach((key) => formData.append(key, product[key]));
        if (image) formData.append("image", image);

        formData.append("bulkDiscounts", JSON.stringify(bulkDiscounts));

        try {
            await createProduct(formData);
            toast.success("Produktet ble opprettet!");
            setTimeout(() => navigate("/products"), 2000);
        } catch (error) {
            toast.error("Feil ved opprettelse av produkt.");
            console.error("Feil:", error);
        }
    };
    
    return (
        <div className="p-4 md:p-6 w-[95%] md:w-[80%] mx-auto bg-white shadow-md mt-4 md:mt-6">
            <ToastContainer position="top-right" autoClose={3000} />
            <h2 className="text-xl md:text-2xl font-bold mb-6 text-gray-800">Opprett nytt produkt</h2>
            
            <form onSubmit={handleSubmit} className="space-y-5">
                <div className='space-y-2'>
                    <label className="block text-gray-500 font-medium">Produktnavn</label>
                    <input type="text" name="name" value={product.name} onChange={handleChange} className="w-full p-3 border rounded" required />
                </div>
                
                <div className='space-y-2'>
                    <label className="block text-gray-500 font-medium">Beskrivelse</label>
                    <textarea name="description" value={product.description} onChange={handleChange} className="w-full p-3 border rounded" rows="4"></textarea>
                </div>

                <div className='space-y-2'>
                    <label className="block text-gray-500 font-medium">Pris (NOK)</label>
                    <input type="number" name="price" value={product.price} onChange={handleChange} className="w-full p-3 border rounded" required />
                </div>

                <div className='space-y-2'>
                    <label className="block text-gray-500 font-medium">Lagerstatus</label>
                    <input type="number" name="stock" value={product.stock} onChange={handleChange} className="w-full p-3 border rounded" required />
                </div>

                <div className='space-y-2'>
                    <label className="block text-gray-500 font-medium">Mersalg (mengderabatter)</label>
                    
                    {bulkDiscounts.map((discount, index) => (
                        <div key={index} className="flex gap-4 items-center">
                            <input 
                                type="number" 
                                value={discount.quantity} 
                                onChange={(e) => handleDiscountChange(index, "quantity", e.target.value)}
                                className="w-1/2 p-3 border rounded" 
                                placeholder="Antall"
                                required
                            />
                            <input 
                                type="number" 
                                value={discount.price} 
                                onChange={(e) => handleDiscountChange(index, "price", e.target.value)}
                                className="w-1/2 p-3 border rounded" 
                                placeholder="Totalpris"
                                required
                            />
                            <button 
                                type="button" 
                                onClick={() => handleRemoveDiscount(index)}
                                className="text-red-500 hover:text-red-700 ml-auto flex items-center justify-center p-1"
                            >
                                <FaTimes size={14} />
                            </button>
                        </div>
                    ))}

                    <button 
                        type="button" 
                        onClick={handleAddDiscount} 
                        className="mt-2 bg-blue-500 text-white py-2 px-4 rounded"
                    >
                        Legg til rabatt
                    </button>
                </div>

                <div className='space-y-2'>
                    <label className="block text-gray-500 font-medium">Kategori</label>
                    <select name="category" value={product.category} onChange={handleChange} className="w-full p-3 border rounded">
                        <option value="jordbær">Jordbær</option>
                        <option value="bringebær">Bringebær</option>
                        <option value="moreller">Moreller</option>
                    </select>
                </div>

                <div className='space-y-2'>
                    <label className="block text-gray-500 font-medium">Last opp bilde</label>
                    <input type="file" onChange={handleImageChange} className="w-full p-3 border rounded" accept="image/*" />
                </div>

                <div className="flex items-center gap-3">
                    <input type="checkbox" name="featured" checked={product.featured} onChange={handleChange} className="w-5 h-5" />
                    <label className="text-gray-500 font-medium">Utvalgt produkt</label>
                </div>

                <button type="submit" className="w-full bg-green-600 text-white py-3 rounded">Lagre produkt</button>
            </form>
        </div>
    )
}

export default CreateProduct